import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryCache,
} from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { apiGetAllLangList, apiGetLangListByCurrency } from "../service";

export const useGetAllLangList = (options) => {
  return useQuery(
    [queryKey.ALL_LANG_LIST],
    () => apiGetAllLangList().then((res) => res.data.data),
    {
      ...options,
    }
  );
};
export const useGetLangListByCurrency = (options) => {
  return useQuery(
    [queryKey.LANG_LIST_BY_CURRENCY],
    () => apiGetLangListByCurrency().then((res) => res.data.data),
    {
      ...options,
    }
  );
};
